import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login.vue'
import Home from '@/views/Home.vue'
import Splash from '@/views/Splash.vue'

Vue.use(Router)

function getUser() {
  try {
    return JSON.parse(localStorage.getItem('usuario')) || null
  } catch (e) {
    return null
  }
}

function getDefaultRouteByRole(tipo) {
  switch (tipo) {
    case 'Proveedor':
      return '/home/proveedor'
    case 'Inventario':
      return '/home/inventario'
    case 'Cajero':
      return '/home/cajero'
    case 'Direccion':
      return '/home/direccion'
    case 'Sistemas':
      return '/home/sistemas'
       case 'Almacen':
   return '/home/Almacen'
    default:
      return '/home'
  }
}

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Splash',
      component: Splash
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/home',
      component: Home,
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          name: 'HomeBase',
          component: () => import('@/views/Blank.vue')
        },

        // PROVEEDOR
        {
          path: 'proveedor',
          name: 'DashboardProveedor',
          component: () => import('@/views/proveedor/DashboardProveedor.vue'),
          meta: { requiresAuth: true, roles: ['Proveedor'] }
        },
        {
          path: 'pedidos',
          name: 'Pedidos',
          component: () => import('@/views/proveedor/Pedidos.vue'),
          meta: { requiresAuth: true, roles: ['Proveedor'] }
        },
        {
          path: 'documentos',
          name: 'Documentos',
          component: () => import('@/views/proveedor/Documentos.vue'),
          meta: { requiresAuth: true, roles: ['Proveedor'] }
        },
        {
          path: 'productos',
          name: 'Productos',
          component: () => import('@/views/proveedor/Productos.vue'),
          meta: { requiresAuth: true, roles: ['Proveedor'] }
        },

        // INVENTARIO
        {
          path: 'inventario',
          name: 'DashboardInventario',
          component: () => import('@/views/inventario/DashboardInventario.vue'),
          meta: { requiresAuth: true, roles: ['Inventario'] }
        },
        {
          path: 'carga-descarga',
          name: 'CargaDescarga',
          component: () => import('@/views/inventario/CargaDescarga.vue'),
          meta: { requiresAuth: true, roles: ['Inventario'] }
        },

        // OTROS TIPOS
        {
          path: 'cajero',
          name: 'DashboardCajero',
          component: () => import('@/views/cajero/DashboardCajero.vue'),
          meta: { requiresAuth: true, roles: ['Cajero'] }
        },
        {
          path: 'direccion',
          name: 'DashboardDireccion',
          component: () => import('@/views/direccion/DashboardDireccion.vue'),
          meta: { requiresAuth: true, roles: ['Direccion'] }
        },
         // ALMACEN
 {
   path: 'almacen',
   name: 'DashboardAlmacen',
   component: () => import('@/views/Almacen/DashboardAlmacen.vue'),
   meta: { requiresAuth: true, roles: ['Almacen'] }
 },

 {
  path: 'almacen/carga',
  name: 'DashboardCarga',
  component: () => import('@/views/Almacen/DashboardCarga.vue'),
  meta: { requiresAuth: true, roles: ['Almacen'] }
},
{
  path: 'almacen/carga-tiempo-real',
  name: 'CargaTiempoReal',
  component: () => import('@/views/Almacen/CargaTiempoReal.vue'),
  meta: { requiresAuth: true,  roles: ['Almacen', 'Inventario'] }
},
{
  path: 'almacen/carga-consulta-x-fecha',
  name: 'CargasxFecha',
  component: () => import('@/views/Almacen/CargasxFecha.vue'),
  meta: { requiresAuth: true, roles: ['Almacen'] }
},


        {
          path: 'sistemas',
          name: 'DashboardSistemas',
          component: () => import('@/views/sistemas/DashboardSistemas.vue'),
          meta: { requiresAuth: true, roles: ['Sistemas'] }
        }
        
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const user = getUser()

  if (to.path === '/' || to.path === '/login') {
    return next()
  }

  if (to.matched.some(record => record.meta.requiresAuth) && !token) {
    return next('/login')
  }

  const roles = to.meta.roles
  if (roles && roles.length > 0) {
    if (!user || !roles.includes(user.tipo)) {
      if (user) {
        return next(getDefaultRouteByRole(user.tipo))
      }
      return next('/login')
    }
  }

  next()
})

export default router